<template>
  <div class="map-controls d-flex m-2 mt-3" :class="{ mobile: useMobileMapControls }">
    <zoom-controls
      class="zoom-controls"
      :is-max-zoom="isMaxZoom"
      :is-min-zoom="isMinZoom"
      :is-default-view="isDefaultView"
      :rounded="rounded"
      v-on="$listeners"
    />
    <basemap-selector
      :basemaps="basemaps"
      :selected-basemap="selectedBasemap"
      :use-mobile-map-controls="useMobileMapControls"
      :rounded="rounded"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import ZoomControls from './ZoomControls.vue';
import BasemapSelector from './BasemapSelector/BasemapSelector.vue';

export default {
  name: 'map-controls',
  components: {
    ZoomControls,
    BasemapSelector,
  },
  props: {
    basemaps: { type: Array, default: () => [] },
    selectedBasemap: { type: String, required: true },
    isMaxZoom: { type: Boolean, required: true },
    isMinZoom: { type: Boolean, required: true },
    isDefaultView: { type: Boolean, required: true },
    useMobileMapControls: { type: Boolean, required: true },
    rounded: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.map-controls {
  position: absolute;
  flex-direction: column;
  pointer-events: none;
  right: 0;
  bottom: 0;

  .zoom-controls {
    text-align: right;
    margin-top: 0px;
    margin-bottom: 4px;
  }

  @media (max-width: 576px) {
    &.mobile {
      flex-direction: column-reverse;
      right: auto;
      bottom: auto;
      left: 0;
      top: 20px;

      .zoom-controls {
        text-align: left;
        margin-top: 8px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
